"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legend = exports.LegendItem = exports.LegendList = void 0;
var React = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("@epic-visualizations/theme");
exports.LegendList = (0, styles_1.styled)("ul")(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        paddingLeft: spacing(11),
        margin: spacing(3, 0),
    });
});
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, typography = _a.typography, palette = _a.palette, shape = _a.shape;
    return ({
        item: __assign(__assign({ display: "inline-flex", alignItems: "center", padding: spacing(1, 2, 1, 1), border: "none", backgroundColor: "unset", color: palette.text.primary }, typography.caption), { "& > span": {
                width: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }, "& svg": {
                fontSize: 8,
            } }),
        itemInteractive: {
            cursor: "pointer",
            borderRadius: shape.borderRadius,
            "&:hover": {
                backgroundColor: palette.background.overlays,
            },
        },
        disabled: {
            pointerEvents: "none",
        },
    });
});
var DefaultIcon = function (_a) {
    var _b = _a.viewBox, viewBox = _b === void 0 ? "0 0 8 8" : _b, props = __rest(_a, ["viewBox"]);
    return (React.createElement(SvgIcon_1.default, __assign({ viewBox: viewBox, height: 9 }, props),
        React.createElement("circle", { cx: "4", cy: "4", r: "4" })));
};
var LegendItem = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? "caption" : _c, interactive = _a.interactive, disabled = _a.disabled, component = _a.component, children = _a.children, icon = _a.icon, iconColor = _a.iconColor, props = __rest(_a, ["variant", "interactive", "disabled", "component", "children", "icon", "iconColor"]);
    var classes = useStyles();
    return (React.createElement(Typography_1.default, __assign({ variant: variant, component: interactive ? "button" : component }, props, { className: (0, clsx_1.default)(classes.item, (_b = {},
            _b[classes.itemInteractive] = interactive,
            _b[classes.disabled] = disabled,
            _b)) }),
        React.createElement("span", { style: { color: iconColor } }, icon || React.createElement(DefaultIcon, null)),
        children));
};
exports.LegendItem = LegendItem;
var Legend = function (_a) {
    var dataKeys = _a.dataKeys, _b = _a.dataColors, dataColors = _b === void 0 ? {} : _b;
    var getComparisonColor = (0, theme_1.useComparisonColor)();
    return (React.createElement(exports.LegendList, null, dataKeys.map(function (key, index) {
        var _a;
        return (React.createElement(exports.LegendItem, { key: key, component: "li", iconColor: getComparisonColor((_a = dataColors[key]) !== null && _a !== void 0 ? _a : index) }, key));
    })));
};
exports.Legend = Legend;
//# sourceMappingURL=Legend.js.map